import React from "react";
import axios from "axios";

export const ApiContext = React.createContext({
  api: axios.create(), // Won't work, just a default.
});
